"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _window = window,
    text = _window.text,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

var _default = function _default(learnMoreLink) {
  return "\n<div class=\"iconContainer\">\n    <div class=\"checkBox\"></div>\n</div>\n<span class=\"small-12 columns signUpSuccess-success primary-color\">".concat(html('idcSignInSuccess.success'), "</span>\n<span class=\"small-12 columns signUpSuccess-startBorrowing\">").concat(html('idcSignInSuccess.startBorrowing'), "</span>\n<span class=\"small-12 columns\">").concat(text('idcSignInSuccess.whenYouComeBack', {
    useMobileNum: "<span class=\"bold\">".concat(html('idcSignInSuccess.useMobileNum'), "</span>")
  }), "</span>\n<span class=\"small-12 columns\">").concat(html('idcSignInSuccess.cardExperiation'), " \n    ").concat(learnMoreLink !== '' ? "<a class=\"signUpSuccess-learnMore secondary-color\" href=\"".concat(learnMoreLink, "\" target=\"_blank\">").concat(html('idcSignInSuccess.learnMore'), "</a>") : "", "\n</span>\n<span class=\"signUpSuccess-happyReading small-12 columns\">").concat(html('idcSignInSuccess.happyReading'), "</span>\n<button class=\"small-12 columns secondary js-close button\">").concat(html('idcSignInSuccess.browseCollection'), "</button>\n");
};

exports["default"] = _default;